document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-menu]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      const open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const target = document.querySelector('[data-gallery-main]');
      if (target) {
        target.src = thumb.dataset.src;
        target.alt = thumb.dataset.alt || '';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const qtyInput = document.querySelector('#QuantityRita');
  const minus = document.querySelector('[data-qty-minus]');
  const plus = document.querySelector('[data-qty-plus]');

  if (qtyInput && minus && plus) {
    minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
    });
    plus.addEventListener('click', function () {
      qtyInput.value = Number(qtyInput.value || 1) + 1;
    });
  }

  const variantsScript = document.querySelector('#ProductVariantsRita');
  const variantSelect = document.querySelector('#VariantSelectRita');
  const optionInputs = document.querySelectorAll('.size-button input');
  const addButton = document.querySelector('.add-to-cart-rita');

  if (variantsScript && variantSelect && optionInputs.length) {
    const variants = JSON.parse(variantsScript.textContent);

    function updateVariant() {
      const selected = Array.from(optionInputs)
        .filter(input => input.checked)
        .map(input => input.value);

      const variant = variants.find(v => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return opts.length === selected.length && opts.every((value, i) => value === selected[i]);
      });

      if (variant) {
        variantSelect.value = variant.id;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
        }
      }
    }

    optionInputs.forEach(input => input.addEventListener('change', updateVariant));
    updateVariant();
  }
});
